import React from "react";
import { isIE, isSafari } from 'react-device-detect';
import { injectIntl } from "react-intl";
import * as paths from '@app/constants/paths';
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
// @material-ui/icons
// core components
import GridContainer from "@app/components/Grid/GridContainer";
import GridItem from "@app/components/Grid/GridItem";
import Button from "@app/components/CustomButtons/Button";
import Card from "@app/components/Card/Card";
import CardFooter from "@app/components/Card/CardFooter";
// IMG
// STEP 3

import featuresStyle from "@app/assets/jss/material-kit-pro-react/views/landingPageSections/featuresStyle";

function OPSCalcLink(props) {
    const { classes } = props;

    const surveyTitle = props.intl.formatMessage({ id: "online.presence.score" });
    const surveyHeadline = props.intl.formatMessage({ id: "calc.o.p.s.online.score.tagline" });
    const surveyCallToAction = props.intl.formatMessage({ id: "get.your.score" });
    const voucherTitle = props.intl.formatMessage({ id: "trading.online.voucher" });
    const voucherHeadline = props.intl.formatMessage({ id: "looking.to.complete.your.application" });
    const voucherHelp = props.intl.formatMessage({ id: "i.need.help" });
    const voucherQuote = props.intl.formatMessage({ id: "i.need.a.quote" });

    return (
        <GridContainer>
            <GridItem
                xs={12}
                sm={12}
                md={8}
                lg={6}
                className={
                classes.mlAuto + " " + classes.mrAuto + " " + classes.textCenter
                }
            >
                <Card raised>
                    <h2 className={classes.title}>
                        {voucherTitle}
                    </h2>
                    <h3 className={classes.description}>
                        {voucherHeadline}
                    </h3>
                    <CardFooter className={classes.buttonAlignCenter}>
                        <Button color="danger" round className={classes.buttons}
                            href={paths.HELPER_T_O_V_S_QUOTE + "?utm_source=" + window.location.hostname + "&utm_medium=LC&utm_campaign=" + window.location.pathname}
                            rel="noopener">
                            <i className="fas fa-star" />{voucherQuote}
                        </Button>
                        <Button color="danger" round className={classes.buttons}
                            href={paths.HELPER_T_O_V_S + "?utm_source=" + window.location.hostname + "&utm_medium=LC&utm_campaign=" + window.location.pathname}
                            rel="noopener">
                            <i className="fas fa-star" />{voucherHelp}
                        </Button>
                    </CardFooter>
                </Card>
            </GridItem>
            <GridItem
                xs={12}
                sm={12}
                md={8}
                lg={6}
                className={
                classes.mlAuto + " " + classes.mrAuto + " " + classes.textCenter
                }
            >
                <Card raised>
                    <h2 className={classes.title}>
                        {surveyTitle}
                    </h2>
                    <h3 className={classes.description}>
                        {surveyHeadline}
                    </h3>
                    <CardFooter className={classes.buttonAlignCenter}>
                        <Button color="danger" round className={classes.buttons}
                            href={paths.TOOL_O_P_S + "?utm_source=" + window.location.hostname + "&utm_medium=LC&utm_campaign=" + window.location.pathname}
                            rel="noopener">
                            <i className="fas fa-star" />{surveyCallToAction}
                        </Button>
                    </CardFooter>
                </Card>
            </GridItem>
        </GridContainer>
        );
    }
    
export default injectIntl(withStyles(featuresStyle)(OPSCalcLink));